<template>
  <v-card>
    <v-system-bar dark window color="info">
      <v-icon center>mdi-information</v-icon>
      <v-toolbar-title class="ml-1">{{data.element_type==='status' ? "Информация о статусе" : "Информация о папке"}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn small icon @click.native="$emit('close-dialog')">
        <v-icon class="mx-0">clear</v-icon>
      </v-btn>
    </v-system-bar>
    
    <v-card-text>
      <v-flex xs12>
        <p>{{data.name}}</p>
        <div v-html="description"></div>
      </v-flex>
    </v-card-text>
    
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="secondary" small @click.native="$emit('close-dialog')">Закрыть</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name : "InfoForm",
    
    props:{
      data: {
        type: Object
      }
    },
    
    created(){
      if(this.data.element_type==='status'){
        this.$store.dispatch('orgstructure/anketa/getStatus', this.data.id).then( response => {
          this.description = response.description
        })
      } else {
        this.$store.dispatch('orgstructure/anketa/getStatusFolder', this.data.id).then( folder => {
          this.description = folder.description
        })
      }
    },
    
    data(){
      return {
        description: ''
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Anketa/Forms/InfoForm.vue